// extracted by mini-css-extract-plugin
module.exports = {"title-wrap":"title-wrap__1JTUn","titleWrap":"title-wrap__1JTUn","title":"title__KoT9M","border":"border__1lxCb"};